<template>
  <div class="m-4">
    <h3 class="text-lg font-semibold mb-3">Personal Details</h3>
    <div>
      <div v-if="donor" class="grid grid-cols-2 gap-4">
        <!-- Left Column -->
        <div class="space-y-6">
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Full Name:</label>
            <p class="text-sm font-normal mt-3">{{ donor.user?.first_name }} {{ donor.user?.last_name }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Gender:</label>
            <p class="text-sm font-normal mt-3">{{ donor.user?.gender }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">D.O.B:</label>
            <p class="text-sm font-normal mt-3">
              {{ donor.user?.dob }} <span class="font-bold">(Age: {{ calculateAge(donor.user?.dob) }})</span>
            </p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Donor Status:</label>
            <p class="text-sm font-normal mt-3">{{ donor.donor_status }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Last Donation Date:</label>
            <p class="text-sm font-normal mt-3">
              {{ donor.last_donation_date ? new Date(donor.last_donation_date).toLocaleDateString('en-CA') : 'N/A' }}
            </p>
          </div>
        </div>
        <!-- Right Column -->
        <div class="space-y-6">
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Patient Name:</label>
            <p class="text-sm font-normal mt-3">{{ donor.patient ? donor.patient : 'N/A' }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Phone</label>
            <p class="text-sm font-normal mt-3">{{ donor.user?.phone_number }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Email:</label>
            <p class="text-sm font-normal mt-3">{{ donor.user?.email }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Donation Type:</label>
            <p class="text-sm font-normal mt-3">{{ donor.donation_status }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Enroll as donor:</label>
            <p class="text-sm font-normal mt-3">{{ donor.enroll_as_donor ? 'Yes' : 'No' }}</p>
          </div>
        </div>
      </div>
      <div v-else>Loading donor details...</div>

      <h3 class="text-lg font-semibold mt-5 mb-3">Donor Contact Information</h3>

      <div v-if="donor" class="grid grid-cols-2 gap-4">
        <!-- Left Column -->
        <div class="space-y-6">
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">County:</label>
            <p class="text-sm font-normal mt-3">{{ donor.county_id?.name }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">work phone:</label>
            <p class="text-sm font-normal mt-3">{{ donor.work_phone ? donor.work_phone : 'N/A' }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Appointment Time:</label>
            <p class="text-sm font-normal mt-3">{{ (donor.donation_bookings && donor.donation_bookings.length > 0) ?
              donor.donation_bookings[0].preferred_time : 'N/A' }}</p>
          </div>
          <div v-if="hasNokDetailsTnh" class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Next of kin Phone:</label>
            <p class="text-sm font-normal mt-3">{{ donor.nok_phone }}</p>
          </div>
        </div>
        <!-- Right Column -->
        <div class="space-y-6">
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">address:</label>
            <p class="text-sm font-normal mt-3"> {{ donor.physical_address }}</p>
          </div>
          <div class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Appointment date:</label>
            <p class="text-sm font-normal mt-3">{{ (donor.donation_bookings && donor.donation_bookings.length > 0) ?
              donor.donation_bookings[0].preferred_date : 'N/A' }}</p>
          </div>
          <div v-if="hasNokDetailsTnh" class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">Next of Kin Names:</label>
            <p class="text-sm font-normal mt-3">{{ donor.nok_names }}</p>
          </div>
          <div v-if="hasNokDetailsTnh" class="grid grid-cols-2 items-center border-t m-2">
            <label class="text-sm font-normal mt-3">NOK Relationship With Donor:</label>
            <p class="text-sm font-normal mt-3">{{ donor.nok_relationship }}</p>
          </div>
        </div>
      </div>
      <div v-else>Loading donor details...</div>

      <h3 class="text-lg font-semibold mt-7 mb-3">Donor Medical Information</h3>

      <table v-if="donor && !aarQuestionnare" class="min-w-full mt-5 bg-white border border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left">
            <th class="px-4 py-2 border-b border-gray-200 w-1/7"> Healthy</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Weigh over 50kgs</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Taking flight</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Active allergy</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Severe disease</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">On medication</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Donated blood / Components</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had covid-19 vaccination</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="{ 'text-red-500': !donor.donor_questionnaire?.feeling_healthy }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.feeling_healthy ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': !donor.donor_questionnaire?.minimum_weight }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.minimum_weight ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.take_flight }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.take_flight ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.active_allergy }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.active_allergy ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.severe_disease }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.severe_disease ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.taking_medication }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.taking_medication ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.donated_blood_component }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.donated_blood_component ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.covid_vaccine }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.covid_vaccine ? 'Yes' : 'No' }}
            </td>
          </tr>
        </tbody>
      </table>
      <table v-else-if="donor && aarQuestionnare" class="min-w-full mt-5 bg-white border border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left">
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Healthy</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Taking flight</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Have Cancer, Neurological or Cardiovascular Disorders
            </th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Taking antibiotics</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had malaria</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">On medication</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Donated blood / Components</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had covid-19 vaccination</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="{ 'text-red-500': !donor.donor_questionnaire?.feeling_healthy }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.feeling_healthy ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.take_flight }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.take_flight ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.severe_disease }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.severe_disease ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_antibiotics }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_antibiotics ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_malaria }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_malaria ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.taking_medication }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.taking_medication ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.donated_blood_component }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.donated_blood_component ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.covid_vaccine }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.covid_vaccine ? 'Yes' : 'No' }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>Loading donor details...</div>
      <table v-if="donor && !aarQuestionnare" class="min-w-full mt-5 bg-white border border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left">
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Taken alcohol</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Taken hard Drugs</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had any surgery</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had any dental work</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had infection exposure</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had blood transfusion /body piercings</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Unexplained sickness</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had Yellow Fever vaccination</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_alcohol }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_alcohol ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_drugs }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_drugs ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_surgery }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_surgery ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.dental_work }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.dental_work ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.infection_exposure }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.infection_exposure ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_body_piercing }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_body_piercing ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.unexplained_sickness }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.unexplained_sickness ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.yellow_fever_vaccine }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.yellow_fever_vaccine ? 'Yes' : 'No' }}</td>
          </tr>
        </tbody>
      </table>
      <table v-else-if="donor && aarQuestionnare" class="min-w-full mt-5 bg-white border border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left">
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had organ transplant</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had body piercing</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had Blood transfusion</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had Body Tatoo</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had Body graft</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Contact with a bleeder</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had needle injury</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Treated with STI</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_organ_transplant }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_organ_transplant ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_body_piercing }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_body_piercing ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_blood_transfusion }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_blood_transfusion ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_tatoo }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_tatoo ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_body_graft }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_body_graft ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.contact_with_a_bleeder }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.contact_with_a_bleeder ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.needle_injury_accident }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.needle_injury_accident ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.treated_sti }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.treated_sti ? 'Yes' : 'No' }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>Loading donor details...</div>
      <table v-if="donor && !aarQuestionnare" class="min-w-full mt-5 bg-white border border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left">
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had hepatitis /Jaundice</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Relative/friends hepatitis</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had immunization /vaccination</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had Hepatitis B or Rabies vaccination</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had a medical condition</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">HIV/AIDS pos</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Have blood disease/bleeding tendencies</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Been rejected as a donor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.pos_for_Hepatitis_C }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.pos_for_Hepatitis_C ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.relative_has_hepatitis }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.relative_has_hepatitis ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.immunization_vaccinations }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.immunization_vaccinations ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.hepatitis_rabies_vaccine }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.hepatitis_rabies_vaccine ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.medical_condition }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.medical_condition ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.positive_for_HIV }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.positive_for_HIV ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.bleeding_condition }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.bleeding_condition ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.rejected_as_donor }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.rejected_as_donor ? 'Yes' : 'No' }}</td>
          </tr>
        </tbody>
      </table>
      <table v-else-if="donor && aarQuestionnare" class="min-w-full mt-5 bg-white border border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left">
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Been in prison last 72 Hrs</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had TB</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Tested POSITIVE for HIV/AIDS</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Injected abused drugs</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had sex for Money</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had heart condition</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Rejected as blood donor</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Read educational Material</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.been_in_prison }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.been_in_prison ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_tb }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_tb ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.positive_for_HIV }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.positive_for_HIV ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.drugs_injection }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.drugs_injection ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.money_for_sex }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.money_for_sex ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_heart_condition }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_heart_condition ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.rejected_as_donor }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.rejected_as_donor ? 'Yes' : 'No' }}
            </td>
            <td :class="{ 'text-red-500': !donor.donor_questionnaire?.read_material }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.read_material ? 'Yes' : 'No' }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>Loading donor details...</div>
      <table v-if="donor && !aarQuestionnare" class="min-w-full mt-5 bg-white border border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left">
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had Blood Transfusion</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had a tatoo</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had an acupuncture</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Currently menstruating</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Currently Breastfeeding</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Currently pregnant</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Agreed to T&Cs</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_blood_transfusion }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_blood_transfusion ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_tatoo }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_tatoo ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.had_acupuncture }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.had_acupuncture ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.has_periods }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.has_periods ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.is_breastfeeding }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.is_breastfeeding ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.is_pregnant }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.is_pregnant ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': !donor.terms_agreed }" class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.terms_agreed ? 'Yes' : 'No' }}
            </td>
          </tr>
        </tbody>
      </table>
      <table v-else-if="donor && aarQuestionnare" class="min-w-full mt-5 bg-white border border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left">
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Had hepatitis /Jaundice</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Have blood disease/bleeding tendencies</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Currently menstruating</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Currently Breastfeeding</th>
            <th class="px-4 py-2 border-b border-gray-200 w-1/7">Currently pregnant</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.pos_for_Hepatitis_C }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.pos_for_Hepatitis_C ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.bleeding_condition }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.bleeding_condition ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.has_periods }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.has_periods ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.is_breastfeeding }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.is_breastfeeding ? 'Yes' : 'No' }}</td>
            <td :class="{ 'text-red-500': donor.donor_questionnaire?.is_pregnant }"
              class="px-4 py-2 border-b border-gray-200 w-1/7">
              {{ donor.donor_questionnaire?.is_pregnant ? 'Yes' : 'No' }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else>Loading donor details...</div>
      <div class="m-20">
        <div class="donor-declaration-section">
          <p class="text-lg font-semibold mb-4">Donor Declaration</p>

          <div class="grid grid-cols-12 gap-6" v-if="donor">
            <!-- Declaration List -->
            <div class="col-span-9">
              <ul class="space-y-3">
                <li class="text-gray-500">
                  a. I have read and understood the pamphlet on "BLOOD DONATION":
                  <b>{{ donor.declaration?.read_educational_material ? 'Yes' : 'No' }}</b>
                </li>
                <li class="text-gray-500">
                  b. I have accurately answered each of the above questions to the best of my knowledge and voluntarily
                  donate blood:
                  <b>{{ donor.declaration?.consent_checkbox ? 'Yes' : 'No' }}</b>
                </li>
                <li class="text-gray-500">
                  c. I understand that my blood will be used for treatment of patients and consent to my blood being
                  tested for HIV, Hepatitis B, Hepatitis C, VDRL and Malaria:
                  <b>{{ donor.declaration?.blood_testing_consent ? 'Yes' : 'No' }}</b>
                </li>
                <li class="text-gray-500">
                  d. I understand that I will be informed of my test results if I choose to:
                  <b>{{ donor.declaration?.terms_agreed ? 'Yes' : 'No' }}</b>
                </li>
                <li class="text-gray-500">
                  e. I consent to further communication by Hospital Donor Center regarding future donations:
                  <b>{{ donor.declaration?.consent_form ? 'Yes' : 'No' }}</b>
                </li>
              </ul>
            </div>

            <!-- Signature -->
            <div class="col-span-3">
              <div v-if="donor.declaration?.signature_url" class="p-4">
                <h3 class="text-sm font-semibold text-orange-400 mb-2">
                  Donor Signature:
                </h3>
                <img :src="donor.declaration?.signature_url" alt="Signature Preview"
                  class="border border-gray-300 rounded bg-white w-full h-auto max-w-full" />
              </div>
              <div class="text-orange-400 p-4" v-else>
                <h3 class="text-sm font-semibold mb-2">Donor Signature:</h3>
                <p class="text-xs">No signature captured</p>
              </div>
            </div>
          </div>
        </div>

        <form>
          <div class="col-span-full">
            <label for="about" class="block text-sm mt-6 font-medium leading-6 text-gray-900">Doctor's Remarks</label>
            <div class="mt-2">
              <textarea id="about" name="about" rows="3"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 bg-gray-100 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"></textarea>
            </div>
          </div>

<div class="mt-8 flex justify-between">
             <button @click="goToPreviousPage"
               class="px-4 py-2 border rounded text-orange-500 border-orange-500">Back</button>
             <div class="flex items-center space-x-4">
               <div v-if="donor && donor.donor_questionnaire?.status === 'New'"
                 class="flex items-center space-x-4 mt-4 sm:mt-0">
                 <CustomButton label="Save and record vitals" bg-class="bg-custom-yellow"
                   @click="showDonationTypeModal = true" />
                 <CustomButton label="Save and defer" bg-class="bg-custom-yellow" @click="handleSaveAndDefer" />
                 <CustomButton label="Edit" bg-class="bg-custom-yellow" @click="editQuestionnaire(donor.donor_id)" />
               </div>
               <div v-else>
                 <CustomButton label="Reinstate" bg-class="px-4 py-3 bg-custom-yellow" @click="handleReinstate" />
               </div>
               <CustomButton label="Print" bg-class="bg-custom-blue" @click="printDonorDetails" />
             </div>
           </div>
         </form>
       </div>

       <DonationTypeModal v-model="showDonationTypeModal" @proceed="handleDonationTypeSelection" />
     </div>
   </div>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';
import DonationTypeModal from '@/views/forms/DonationTypeModal.vue';
import api from '@/services/api';
import { SweetAlertService } from '@/services/SweetAlertService';

export default {
  name: 'DonorQuestionnaireInformation',
  components: {
    CustomButton,
    DonationTypeModal
  },

  data() {
    return {
      donor: null,
      error: null,
      flags: [],
      hasNokDetailsTnh: false,
      aarQuestionnare: false,
      facility_logo: null,
      showDonationTypeModal: false,
    }
  },

  created() {
    this.getDonors();
  },

  mounted() {
    this.flags = this.$store.getters["auth/flags"];
    this.hasNokDetailsTnh = this.flags.some(flag => flag === "TNH Next of Kin Details");
    this.aarQuestionnare = this.flags.some(flag => flag === "AAR Questionnaire");
    const userData = this.$store.getters["auth/user"];
    this.facility_logo = userData?.user_roles[0]?.facility_department?.facility?.logo || '';
  },

  methods: {
    editQuestionnaire(donorId) {
      console.log('Passing donor:', donorId);
      this.$router.push({
        name: 'EditDonorQuestionnairePage',
        params: { donor_id: donorId }
      });
    },

    calculateAge(dob) {
      if (!dob) return 'N/A';
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },

    handleDonationTypeSelection(type) {
      this.showDonationTypeModal = false;
      const donorId = this.$route.params.donor_id;
      if (type === 'normal') {
        this.$router.push({
          name: 'NewDonorVitalsForm',
          params: { donor_id: donorId }
        });
      } else if (type === 'apheresis') {
        this.$router.push({
          name: 'NewApheresisScreeningForm',
          params: { donor_id: donorId }
        });
      }
    },

    handleSaveAndDefer() {
      this.$router.push({
        name: 'NewDonorDeferralForm',
        params: { donor_id: this.$route.params.donor_id }
      });
    },

    async handleReinstate() {
      try {
        const donorId = this.$route.params.donor_id;
        console.log('Donor ID:', donorId);

        const data = { status: "New" };
        console.log('Payload being sent:', data);

        const response = await api.updateDonorQuestionnaireStatus(donorId, data);

        this.donor = response?.data || response;
        await SweetAlertService.showSuccess('Reinstated', 'Questionnaire Reinstated successfully.');
        this.$router.push({ name: 'DonorManagementPage' });
      } catch (error) {
        console.error('Error updating donor questionnaire status:', error);
        this.error = error.response?.data?.message || error.message ||
          'Failed to update donor questionnaire status';
      }
    },

    goToPreviousPage() {
      this.$router.push({
        name: 'DonorManagementPage',
      });
    },

    async getDonors() {
      try {
        const donorId = this.$route.params.donor_id;
        console.log('Fetching details for donor ID:', donorId);
        const response = await api.getDonor(donorId);
        this.donor = response.data || response;
        console.log('data:', this.donor);
      } catch (error) {
        this.error = error.message || 'Failed to fetch donors';
      }
    },

    formatDateISO(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    },

    printDonorDetails() {
      const donorData = JSON.parse(JSON.stringify(this.donor));
      const printWindow = document.createElement('iframe');
      printWindow.style.position = 'absolute';
      printWindow.style.width = '0';
      printWindow.style.height = '0';
      printWindow.style.border = 'none';
      document.body.appendChild(printWindow);

      try {
        const printContent = `
      <div class="page-container">
        <div class="report-container">
          <div class="header-section">
            <div class="logo-container">
              <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
            </div>
            <h1 class="report-title">Donor Questionnaire Details</h1>
            <div class="report-date">Generated on: ${new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}</div>
          </div>

          <div class="content-wrapper">
            <div class="section personal-info">
              <div class="section-header">
                <h2 class="section-title">Personal Information</h2>
              </div>
              <div class="info-grid">
                <div class="info-column">
                  <div class="info-item">
                    <span class="info-label">Full Name:</span>
                    <span class="info-value">${donorData.user?.first_name} ${donorData.user?.last_name}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Gender:</span>
                    <span class="info-value">${donorData.user?.gender || 'N/A'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Date of Birth:</span>
                    <span class="info-value">${donorData.user?.dob ? this.formatDateISO(donorData.user.dob) : 'N/A'} (Age: ${this.calculateAge(donorData.user?.dob)})</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Donor Status:</span>
                    <span class="info-value">${donorData.donor_status || 'N/A'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Donation Type:</span>
                    <span class="info-value">${donorData.donation_status || 'N/A'}</span>
                  </div>
                </div>
                <div class="info-column">
                  <div class="info-item">
                    <span class="info-label">Phone:</span>
                    <span class="info-value">${donorData.user?.phone_number || 'N/A'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Email:</span>
                    <span class="info-value">${donorData.user?.email || 'N/A'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Enroll as Donor:</span>
                    <span class="info-value">${donorData.enroll_as_donor ? 'Yes' : 'No'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Last Donation Date:</span>
                    <span class="info-value">${donorData.last_donation_date ? this.formatDateISO(donorData.last_donation_date) : 'N/A'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Patient Name:</span>
                    <span class="info-value">${donorData.patient || 'N/A'}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="section contact-info">
              <div class="section-header">
                <h2 class="section-title">Contact Information</h2>
              </div>
              <div class="info-grid">
                <div class="info-column">
                  <div class="info-item">
                    <span class="info-label">County:</span>
                    <span class="info-value">${donorData.county_id?.name || 'N/A'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Physical Address:</span>
                    <span class="info-value">${donorData.physical_address || 'N/A'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Work Phone:</span>
                    <span class="info-value">${donorData.work_phone || 'N/A'}</span>
                  </div>
                </div>
                <div class="info-column">
                  <div class="info-item">
                    <span class="info-label">Appointment Date:</span>
                    <span class="info-value">${(donorData.donation_bookings && donorData.donation_bookings.length > 0) ? this.formatDateISO(donorData.donation_bookings[0].preferred_date) : 'N/A'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Appointment Time:</span>
                    <span class="info-value">${(donorData.donation_bookings && donorData.donation_bookings.length > 0) ? donorData.donation_bookings[0].preferred_time || 'N/A' : 'N/A'}</span>
                  </div>
                  ${this.hasNokDetailsTnh ? `
                    <div class="info-item">
                      <span class="info-label">Next of Kin Names:</span>
                      <span class="info-value">${donorData.nok_names || 'N/A'}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Next of Kin Phone:</span>
                      <span class="info-value">${donorData.nok_phone || 'N/A'}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">NOK Relationship:</span>
                      <span class="info-value">${donorData.nok_relationship || 'N/A'}</span>
                    </div>
                  ` : ''}
                </div>
              </div>
            </div>

            <div class="section questionnaire-section">
              <div class="section-header">
                <h2 class="section-title">Medical Questionnaire</h2>
              </div>
              <div class="table-wrapper">
                <table class="questionnaire-table">
                  <thead>
                    <tr>
                      <th class="question-header">Question</th>
                      <th class="response-header">Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${this.aarQuestionnare ? `
                      <tr><td class="question-cell">Feeling Healthy</td><td class="response-cell">${donorData.donor_questionnaire?.feeling_healthy ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Taking Flight</td><td class="response-cell">${donorData.donor_questionnaire?.take_flight ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Have Cancer, Neurological or Cardiovascular Disorders</td><td class="response-cell">${donorData.donor_questionnaire?.severe_disease ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Taking Antibiotics</td><td class="response-cell">${donorData.donor_questionnaire?.had_antibiotics ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Malaria</td><td class="response-cell">${donorData.donor_questionnaire?.had_malaria ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">On Medication</td><td class="response-cell">${donorData.donor_questionnaire?.taking_medication ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Donated Blood/Components</td><td class="response-cell">${donorData.donor_questionnaire?.donated_blood_component ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had COVID-19 Vaccination</td><td class="response-cell">${donorData.donor_questionnaire?.covid_vaccine ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Organ Transplant</td><td class="response-cell">${donorData.donor_questionnaire?.had_organ_transplant ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Body Piercing</td><td class="response-cell">${donorData.donor_questionnaire?.had_body_piercing ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Blood Transfusion</td><td class="response-cell">${donorData.donor_questionnaire?.had_blood_transfusion ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Body Tattoo</td><td class="response-cell">${donorData.donor_questionnaire?.had_tatoo ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Body Graft</td><td class="response-cell">${donorData.donor_questionnaire?.had_body_graft ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Contact with a Bleeder</td><td class="response-cell">${donorData.donor_questionnaire?.contact_with_a_bleeder ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Needle Injury</td><td class="response-cell">${donorData.donor_questionnaire?.needle_injury_accident ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Treated with STI</td><td class="response-cell">${donorData.donor_questionnaire?.treated_sti ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Been in Prison Last 72 Hrs</td><td class="response-cell">${donorData.donor_questionnaire?.been_in_prison ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had TB</td><td class="response-cell">${donorData.donor_questionnaire?.had_tb ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Tested Positive for HIV/AIDS</td><td class="response-cell">${donorData.donor_questionnaire?.positive_for_HIV ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Injected Abused Drugs</td><td class="response-cell">${donorData.donor_questionnaire?.drugs_injection ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Sex for Money</td><td class="response-cell">${donorData.donor_questionnaire?.money_for_sex ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Heart Condition</td><td class="response-cell">${donorData.donor_questionnaire?.had_heart_condition ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Rejected as Blood Donor</td><td class="response-cell">${donorData.donor_questionnaire?.rejected_as_donor ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Read Educational Material</td><td class="response-cell">${donorData.donor_questionnaire?.read_material ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Hepatitis/Jaundice</td><td class="response-cell">${donorData.donor_questionnaire?.pos_for_Hepatitis_C ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Have Blood Disease/Bleeding Tendencies</td><td class="response-cell">${donorData.donor_questionnaire?.bleeding_condition ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Currently Menstruating</td><td class="response-cell">${donorData.donor_questionnaire?.has_periods ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Currently Breastfeeding</td><td class="response-cell">${donorData.donor_questionnaire?.is_breastfeeding ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Currently Pregnant</td><td class="response-cell">${donorData.donor_questionnaire?.is_pregnant ? 'Yes' : 'No'}</td></tr>
                    ` : `
                      <tr><td class="question-cell">Feeling Healthy</td><td class="response-cell">${donorData.donor_questionnaire?.feeling_healthy ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Weigh over 50kgs</td><td class="response-cell">${donorData.donor_questionnaire?.minimum_weight ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Taking Flight</td><td class="response-cell">${donorData.donor_questionnaire?.take_flight ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Active Allergy</td><td class="response-cell">${donorData.donor_questionnaire?.active_allergy ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Severe Disease</td><td class="response-cell">${donorData.donor_questionnaire?.severe_disease ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">On Medication</td><td class="response-cell">${donorData.donor_questionnaire?.taking_medication ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Donated Blood/Components</td><td class="response-cell">${donorData.donor_questionnaire?.donated_blood_component ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had COVID-19 Vaccination</td><td class="response-cell">${donorData.donor_questionnaire?.covid_vaccine ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Taken Alcohol</td><td class="response-cell">${donorData.donor_questionnaire?.had_alcohol ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Taken Hard Drugs</td><td class="response-cell">${donorData.donor_questionnaire?.had_drugs ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Any Surgery</td><td class="response-cell">${donorData.donor_questionnaire?.had_surgery ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Any Dental Work</td><td class="response-cell">${donorData.donor_questionnaire?.dental_work ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Infection Exposure</td><td class="response-cell">${donorData.donor_questionnaire?.infection_exposure ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Blood Transfusion/Body Piercings</td><td class="response-cell">${donorData.donor_questionnaire?.had_body_piercing ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Unexplained Sickness</td><td class="response-cell">${donorData.donor_questionnaire?.unexplained_sickness ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Yellow Fever Vaccination</td><td class="response-cell">${donorData.donor_questionnaire?.yellow_fever_vaccine ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Hepatitis/Jaundice</td><td class="response-cell">${donorData.donor_questionnaire?.pos_for_Hepatitis_C ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Relative/Friends Hepatitis</td><td class="response-cell">${donorData.donor_questionnaire?.relative_has_hepatitis ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Immunization/Vaccination</td><td class="response-cell">${donorData.donor_questionnaire?.immunization_vaccinations ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Hepatitis B or Rabies Vaccination</td><td class="response-cell">${donorData.donor_questionnaire?.hepatitis_rabies_vaccine ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had a Medical Condition</td><td class="response-cell">${donorData.donor_questionnaire?.medical_condition ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">HIV/AIDS Positive</td><td class="response-cell">${donorData.donor_questionnaire?.positive_for_HIV ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Have Blood Disease/Bleeding Tendencies</td><td class="response-cell">${donorData.donor_questionnaire?.bleeding_condition ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Been Rejected as a Donor</td><td class="response-cell">${donorData.donor_questionnaire?.rejected_as_donor ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had Blood Transfusion</td><td class="response-cell">${donorData.donor_questionnaire?.had_blood_transfusion ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had a Tattoo</td><td class="response-cell">${donorData.donor_questionnaire?.had_tatoo ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Had an Acupuncture</td><td class="response-cell">${donorData.donor_questionnaire?.had_acupuncture ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Currently Menstruating</td><td class="response-cell">${donorData.donor_questionnaire?.has_periods ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Currently Breastfeeding</td><td class="response-cell">${donorData.donor_questionnaire?.is_breastfeeding ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Currently Pregnant</td><td class="response-cell">${donorData.donor_questionnaire?.is_pregnant ? 'Yes' : 'No'}</td></tr>
                      <tr><td class="question-cell">Agreed to T&Cs</td><td class="response-cell">${donorData.terms_agreed ? 'Yes' : 'No'}</td></tr>
                    `}
                  </tbody>
                </table>
              </div>
            </div>

            <div class="section declaration-section">
              <div class="section-header">
                <h2 class="section-title">Donor Declaration</h2>
              </div>
              <div class="declaration-content">
                <div class="declaration-items">
                  <div class="info-item">
                    <span class="info-label">Read Educational Material:</span>
                    <span class="info-value">${donorData.declaration?.read_educational_material ? 'Yes' : 'No'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Consent to Blood Donation:</span>
                    <span class="info-value">${donorData.declaration?.consent_checkbox ? 'Yes' : 'No'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Blood Testing Consent:</span>
                    <span class="info-value">${donorData.declaration?.blood_testing_consent ? 'Yes' : 'No'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Informed of Test Results:</span>
                    <span class="info-value">${donorData.declaration?.terms_agreed ? 'Yes' : 'No'}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Consent to Further Communication:</span>
                    <span class="info-value">${donorData.declaration?.consent_form ? 'Yes' : 'No'}</span>
                  </div>
                </div>
                <div class="signature-section">
                  <div class="signature-label">Donor Signature:</div>
                  ${donorData.declaration?.signature_url ? `
                    <div class="signature-container">
                      <img src="${donorData.declaration.signature_url}" alt="Donor Signature" class="signature-image">
                    </div>
                  ` : `
                    <div class="no-signature">No signature captured</div>
                  `}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

        const printDocument = `
      <html>
      <head>
        <title>Donor Questionnaire Details</title>
        <style>
          /* Reset and Base Styles */
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }

          @media print {
            @page {
              size: A4;
              margin: 1.5cm;
            }
            
            body {
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }
            
            .section {
              page-break-inside: avoid;
            }
            
            .questionnaire-section {
              page-break-inside: avoid;
            }
          }

          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #2c3e50;
            background: #ffffff;
          }

          /* Page Container */
          .page-container {
            max-width: 210mm;
            margin: 0 auto;
            padding: 20px;
            background: white;
          }

          .report-container {
            width: 100%;
          }

          /* Header Section */
          .header-section {
            text-align: center;
            margin-bottom: 30px;
            border-bottom: 3px solid #FAB950;
            padding-bottom: 20px;
          }

          .logo-container {
            margin-bottom: 15px;
          }

          .logo {
            max-width: 150px;
            height: auto;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          }

          .report-title {
            font-size: 28px;
            font-weight: 700;
            color: #2c3e50;
            margin: 15px 0 8px 0;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .report-date {
            font-size: 14px;
            color: #7f8c8d;
            font-style: italic;
          }

          /* Content Wrapper */
          .content-wrapper {
            margin-top: 20px;
          }

          /* Section Styles */
          .section {
            margin-bottom: 25px;
            background: #ffffff;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          }

          .section-header {
            padding: 12px 20px;
            margin-bottom: 0;
          }

          .section-title {
            font-size: 18px;
            font-weight: 600;
            color: black;
            margin: 0;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          /* Info Grid */
          .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 25px;
            padding: 20px;
          }

          .info-column {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .info-item {
            display: flex;
            flex-direction: column;
            padding: 5px;
          }

          .info-label {
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .info-value {
            font-size: 14px;
            font-weight: 500;
            color: #2c3e50;
            word-break: break-word;
          }

          /* Table Styles */
          .table-wrapper {
            padding: 20px;
            background: #fafafa;
          }

          .questionnaire-table {
            width: 100%;
            border-collapse: collapse;
            border-radius: 8px;
            overflow: hidden;
          }

          .questionnaire-table thead {
            background: #e0e0e0;
          }

          .question-header,
          .response-header {
            padding: 15px 12px;
            font-weight: 600;
            color: black;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            font-size: 13px;
          }

          .question-header {
            width: 70%;
            text-align: left;
          }

          .response-header {
            width: 30%;
            text-align: center;
          }

          .questionnaire-table tbody tr {
            transition: background-color 0.2s ease;
          }

          .questionnaire-table tbody tr:nth-child(even) {
            background-color: #f8f9fa;
          }

          .questionnaire-table tbody tr:hover {
            background-color: #e8f4f8;
          }

          .question-cell {
            padding: 12px;
            border-bottom: 1px solid #dee2e6;
            font-size: 13px;
            color: #2c3e50;
            font-weight: 500;
          }

          .response-cell {
            padding: 12px;
            border-bottom: 1px solid #dee2e6;
            text-align: center;
            font-weight: 600;
            font-size: 13px;
          }

          /* Declaration Section */
          .declaration-content {
            padding: 20px;
          }

          .declaration-items {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;
            margin-bottom: 25px;
          }

          .signature-section {
            background: white;
            padding: 20px;
            border-radius: 8px;
            border: 2px dashed #bdc3c7;
            text-align: center;
          }

          .signature-label {
            font-size: 14px;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 15px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .signature-container {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 80px;
            background: #f8f9fa;
            border-radius: 6px;
            border: 1px solid #dee2e6;
          }

          .signature-image {
            max-width: 200px;
            max-height: 80px;
            height: auto;
            border-radius: 4px;
          }

          .no-signature {
            color: #95a5a6;
            font-style: italic;
            padding: 20px;
            background: #ecf0f1;
            border-radius: 6px;
            border: 2px dashed #bdc3c7;
          }

          /* Responsive Design for smaller screens */
          @media screen and (max-width: 768px) {
            .info-grid,
            .declaration-items {
              grid-template-columns: 1fr;
              gap: 15px;
            }
            
            .page-container {
              padding: 15px;
            }
            
            .report-title {
              font-size: 24px;
            }
            
            .section-title {
              font-size: 16px;
            }
          }

          /* Print-specific adjustments */
          @media print {
            .page-container {
              padding: 10px;
              box-shadow: none;
            }
            
            .section {
              box-shadow: none;
              border: 1px solid #dee2e6;
              margin-bottom: 15px;
            }
            
            .questionnaire-table {
              box-shadow: none;
              border: 1px solid #dee2e6;
            }
            
            .signature-section {
              border: 1px solid #bdc3c7;
            }
          }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `;

        printWindow.contentDocument.open();
        printWindow.contentDocument.write(printDocument);
        printWindow.contentDocument.close();

        printWindow.contentWindow.onload = function () {
          printWindow.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(printWindow);
          }, 1000);
        };
      } catch (error) {
        console.error('Error generating print content:', error);
        document.body.removeChild(printWindow);
      }
    },
  },
}
</script>

<style scoped></style>